import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../Store/Store";

export default function PrivateRoute() {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isAuth);
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" state={{ r: true }} />;
}
